import { ComponentProps, useCallback } from 'react';
import { useTracking } from 'react-tracking';

import { Heading } from '@simplywallst/ui-core';
import type { Grid } from '@simplywallst/ui-core';

import PortfolioDropdown from '@/components/PortfolioDropdown';

import type { Portfolio } from '@/hooks/usePortfolio';

import { PageHeader } from './styled';

type Props = ComponentProps<typeof Grid> & {
  portfolio?: Portfolio;
};

export const PortfolioPageHeader = ({
  portfolio,
  children,
  ...props
}: Props) => {
  const { trackEvent } = useTracking({ type: 'track' });

  const trackDropdownClick = useCallback(() => {
    trackEvent({
      modifier: 'myPortfolioDropDown',
      // Force subject to be page
      subject: 'page',
      action: 'click',
    });
  }, [trackEvent]);

  return (
    <PageHeader
      as="header"
      data-cy-id="portfolio-header"
      templateRows="auto"
      templateColumns="auto min-content"
      templateColumnsMd="auto auto"
      justifyContentMd="space-between"
      {...props}
    >
      <PortfolioDropdown
        portfolioId={portfolio?.id ?? null}
        onClick={trackDropdownClick}
      >
        <Heading as="h1" typography="megaStrong" isTruncated>
          {portfolio?.name ?? 'My Portfolio'}
        </Heading>
      </PortfolioDropdown>
      {children}
    </PageHeader>
  );
};
